import { Icon, IconType as AssemblyIconType } from '@assembly-js/design-system';
import { useContext } from 'react';

import {
  BillingIcon,
  BookOpenIcon,
  ChatBubble,
  ContractIcon,
  DashboardIcon,
  FolderFillIcon,
  FormsFilledIcon,
  IconNameToComponent,
  IconType,
} from 'src/components/icons';
import { ModuleSettingsItem } from 'src/constants/dataTypes';
import { FlagsContext } from 'src/context';
import { useGetInstallsQuery } from 'src/services/api/applicationsApi';
import { CoreModule } from 'src/types/modules';

const emptyModules: ModuleSettingsItem[] = [];

export const useModuleIcon = (moduleName: CoreModule) => {
  const { data: settings } = useGetInstallsQuery();
  const modules = settings?.moduleSettings || emptyModules;
  const module = modules.find((m) => m.id === moduleName);

  const { EnableIconPicker } = useContext(FlagsContext);
  const LegacyIconComponent = IconNameToComponent[module?.icon as IconType];

  if (EnableIconPicker) {
    return (
      <Icon
        icon={(module?.icon as AssemblyIconType) ?? 'dashboard'}
        className="w-6 h-6"
      />
    );
  }

  if (LegacyIconComponent) {
    return <LegacyIconComponent className="w-6 h-6" />;
  }

  switch (moduleName) {
    case 'payments':
      return <BillingIcon className="w-6 h-6" />;
    case 'forms':
      return <FormsFilledIcon className="w-6 h-6" />;
    case 'knowledgeBase':
      return <BookOpenIcon className="w-6 h-6" />;
    case 'files':
      return <FolderFillIcon className="w-6 h-6" />;
    case 'messages':
      return <ChatBubble className="w-6 h-6" />;
    case 'contracts':
      return <ContractIcon className="w-6 h-6" />;
    default:
      return <DashboardIcon className="w-6 h-6" />;
  }
};
